let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8o3P2")).then(() => parcelRequire('3jBFZ'));